module.exports = __webpack_public_path__ + "static/media/young-lady-in-vineyards_1600x1600.aa61bf41.jpg";